(() => {
  const root = document.documentElement;
  const header = document.querySelector('[data-wy-header]');
  const drawer = document.querySelector('[data-wy-drawer]');
  const menuButtons = document.querySelectorAll('[data-wy-menu-toggle]');

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.hidden = true;
    root.classList.remove('wy-drawer-open');
    menuButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
  };

  const openDrawer = () => {
    if (!drawer) return;
    drawer.hidden = false;
    root.classList.add('wy-drawer-open');
    menuButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
  };

  menuButtons.forEach((button) => {
    button.addEventListener('click', () => drawer && drawer.hidden ? openDrawer() : closeDrawer());
  });
  drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawer(); });

  const enquiry = document.querySelector('[data-wy-enquiry]');
  const enquiryOpeners = document.querySelectorAll('[data-wy-enquiry-open]');
  const enquiryClosers = document.querySelectorAll('[data-wy-enquiry-close]');
  const closeEnquiry = () => {
    if (!enquiry) return;
    enquiry.hidden = true;
    root.classList.remove('wy-enquiry-open');
    enquiryOpeners.forEach((button) => button.setAttribute('aria-expanded', 'false'));
  };
  const openEnquiry = () => {
    if (!enquiry) return;
    enquiry.hidden = false;
    root.classList.add('wy-enquiry-open');
    enquiryOpeners.forEach((button) => button.setAttribute('aria-expanded', 'true'));
    enquiry.querySelector('input:not([type="hidden"]), button')?.focus();
  };
  enquiryOpeners.forEach((button) => button.addEventListener('click', openEnquiry));
  enquiryClosers.forEach((button) => button.addEventListener('click', closeEnquiry));
  if (enquiry?.querySelector('[data-wy-enquiry-success], .errors')) openEnquiry();
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeEnquiry(); });

  document.querySelectorAll('[data-wy-product-form]').forEach((form) => {
    const variantSelect = form.querySelector('[data-wy-variant-select]');
    const addButton = form.querySelector('[data-wy-add-to-cart]');
    const syncAvailability = () => {
      if (!variantSelect || !addButton) return;
      const option = variantSelect.options[variantSelect.selectedIndex];
      const available = option && option.dataset.available === 'true';
      addButton.disabled = !available;
      addButton.textContent = available ? addButton.dataset.addLabel : addButton.dataset.soldLabel;
    };
    variantSelect?.addEventListener('change', syncAvailability);
    syncAvailability();
  });

  const setHeaderState = () => header?.classList.toggle('is-scrolled', window.scrollY > 24);
  setHeaderState();
  addEventListener('scroll', setHeaderState, { passive: true });

  document.querySelectorAll('[data-wy-filter-scope]').forEach((scope) => {
    const cards = [...scope.querySelectorAll('[data-wy-product-card]')];
    const query = scope.querySelector('[data-wy-search]');
    const conditionButtons = [...scope.querySelectorAll('[data-wy-condition]')];
    const priceButtons = [...scope.querySelectorAll('[data-wy-price]')];
    const loaButtons = [...scope.querySelectorAll('[data-wy-loa]')];
    const count = scope.querySelector('[data-wy-results]');
    const empty = scope.querySelector('[data-wy-empty]');
    let condition = 'all';
    let price = 'all';
    let loa = 'all';

    const markActive = (buttons, active) => buttons.forEach((button) => button.classList.toggle('is-active', button.dataset.value === active));
    const apply = () => {
      const term = (query?.value || '').trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const text = card.dataset.search || '';
        const cardCondition = card.dataset.condition || '';
        const cardPrice = Number(card.dataset.price || 0) / 100;
        const cardLoa = Number(card.dataset.loa || 0);
        const queryOk = !term || text.includes(term);
        const conditionOk = condition === 'all' || cardCondition.includes(condition);
        const priceOk = price === 'all' ||
          (price === 'under1' && cardPrice < 1000000) ||
          (price === '1to3' && cardPrice >= 1000000 && cardPrice < 3000000) ||
          (price === '3to8' && cardPrice >= 3000000 && cardPrice < 8000000) ||
          (price === 'over8' && cardPrice >= 8000000);
        const loaOk = loa === 'all' ||
          (loa === 'under16' && cardLoa && cardLoa < 16) ||
          (loa === '16to22' && cardLoa >= 16 && cardLoa < 22) ||
          (loa === 'over22' && cardLoa >= 22);
        const show = queryOk && conditionOk && priceOk && loaOk;
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (count) count.textContent = `${visible} ${count.dataset.label || 'listings'}`;
      if (empty) empty.hidden = visible !== 0;
    };

    query?.addEventListener('input', apply);
    conditionButtons.forEach((button) => button.addEventListener('click', () => { condition = button.dataset.value; markActive(conditionButtons, condition); apply(); }));
    priceButtons.forEach((button) => button.addEventListener('click', () => { price = button.dataset.value; markActive(priceButtons, price); apply(); }));
    loaButtons.forEach((button) => button.addEventListener('click', () => { loa = button.dataset.value; markActive(loaButtons, loa); apply(); }));
    apply();
  });

  document.querySelectorAll('[data-wy-rail]').forEach((rail) => {
    rail.parentElement?.querySelector('[data-wy-prev]')?.addEventListener('click', () => rail.scrollBy({ left: -Math.min(rail.clientWidth * .8, 600), behavior: 'smooth' }));
    rail.parentElement?.querySelector('[data-wy-next]')?.addEventListener('click', () => rail.scrollBy({ left: Math.min(rail.clientWidth * .8, 600), behavior: 'smooth' }));
  });

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.isIntersecting) entry.target.classList.add('is-visible'); });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  document.querySelectorAll('[data-wy-reveal]').forEach((element) => observer ? observer.observe(element) : element.classList.add('is-visible'));

  document.addEventListener('shopify:section:load', () => location.reload());
})();
